import { render, staticRenderFns } from "./customdynamiclist.vue?vue&type=template&id=452e9304&"
import script from "./customdynamiclist.vue?vue&type=script&lang=js&"
export * from "./customdynamiclist.vue?vue&type=script&lang=js&"
import style0 from "./customdynamiclist.vue?vue&type=style&index=0&id=452e9304&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports